// import physics from './images/physics.png'
// import science from './images/science.png'
// import maths from './images/maths.png'
// import chm from './images/chemistry.png'
// import geo from './images/geography.png'
// import hist from './images/history.png'
// import ar from './images/books.png'
// import en from './images/engllish.png'
// import about_image from './images/about_image.jpg'
// import header_image_1 from './images/header_image_1.jpg'
// import header_image_2 from './images/header_image_2.jpg'
// import header_image_3 from './images/header_image_3.png'
// import middle_image from './images/middle_image.jpg'

// import {
// Stethoscope,
// HeartPulse,
// Microscope,
// Eye,
// Bone,
// Syringe,
// Baby,
// Venus,
// Scissors,
// Dumbbell,
// Brain,
// Ear,
// Shield,
// UserCheck,
// Thermometer,
// TestTube,
// Scan,
// Ambulance,
// Users,
// Apple,
// Smile,
// Droplet,
// Wind,
// User,
// Pill,
// } from "lucide-react";



// export const city = [
//     { key: 'damascus', name: "دمشق" },
//     { key: 'damascus_countryside', name: "ريف دمشق" },
//     { key: 'aleppo', name: "حلب" },
//     { key: 'homs', name: "حمص" },
//     { key: 'hama', name: "حماة" },
//     { key: 'lattakia', name: "اللاذقية" },
//     { key: 'tartus', name: "طرطوس" },
//     { key: 'idlib', name: "إدلب" },
//     { key: 'daraa', name: "درعا" },
//     { key: 'suweida', name: "السويداء" },
//     { key: 'quneitra', name: "القنيطرة" },
//     { key: 'deir_ez_zor', name: "دير الزور" },
//     { key: 'raqqa', name: "الرقة" },
//     { key: 'hasakah', name: "الحسكة" }
// ];

// // المناطق حسب كل محافظة
// export const regions = {
//     damascus: [
//         { region: "الشاغور", translation: "Al-Shaghour" },
//         { region: "باب توما", translation: "Bab Touma" },
//         { region: "القصاع", translation: "Al-Qassa" },
//         { region: "الصالحية", translation: "Al-Salihiyah" },
//         { region: "المهاجرين", translation: "Al-Muhajirin" },
//         { region: "أبو رمانة", translation: "Abu Rummanah" },
//         { region: "المالكي", translation: "Al-Malki" },
//         { region: "الروضة", translation: "Al-Rawdah" },
//         { region: "كفرسوسة", translation: "Kafr Souseh" },
//         { region: "المزة", translation: "Al-Mazza" },
//         { region: "دمر", translation: "Dummar" },
//         { region: "المزرعة", translation: "Al-Mazra'a" },
//         { region: "برزة", translation: "Barzah" },
//         { region: "التجارة", translation: "Al-Tijara" },
//         { region: "جوبر", translation: "Jobar" },
//         { region: "زملكا", translation: "Zamalka" },
//         { region: "عين ترما", translation: "Ain Terma" }
//     ],

//     damascus_countryside: [
//         { region: "دوما", translation: "Douma" },
//         { region: "الزبداني", translation: "Al-Zabadani" },
//         { region: "بلودان", translation: "Bloudan" },
//         { region: "مضايا", translation: "Madaya" },
//         { region: "عرسال", translation: "Arsal" },
//         { region: "النبك", translation: "Al-Nabk" },
//         { region: "يبرود", translation: "Yabroud" },
//         { region: "معلولا", translation: "Maaloula" },
//         { region: "صيدنايا", translation: "Saidnaya" },
//         { region: "قطنا", translation: "Qatana" },
//         { region: "الكسوة", translation: "Al-Kiswah" },
//         { region: "داريا", translation: "Daraya" },
//         { region: "المعضمية", translation: "Al-Mu'addamiyah" },
//         { region: "قدسيا", translation: "Qudsaya" },
//         { region: "حرستا", translation: "Harasta" },
//         { region: "عربين", translation: "Arbin" },
//         { region: "سقبا", translation: "Saqba" },
//         { region: "مليحة", translation: "Maliha" }
//     ],

//     aleppo: [
//         { region: "العزيزية", translation: "Al-Aziziyah" },
//         { region: "الشعار", translation: "Al-Sha'ar" },
//         { region: "بستان الباشا", translation: "Bustan al-Basha" },
//         { region: "الصاخور", translation: "Al-Sakhour" },
//         { region: "الحيدرية", translation: "Al-Haidariyah" },
//         { region: "الميدان", translation: "Al-Maydan" },
//         { region: "العقبة", translation: "Al-Aqabah" },
//         { region: "الفردوس", translation: "Al-Firdous" },
//         { region: "الأشرفية", translation: "Al-Ashrafiyah" },
//         { region: "الموكامبو", translation: "Al-Mogambo" },
//         { region: "الحمدانية", translation: "Al-Hamdaniyah" },
//         { region: "الفرقان", translation: "Al-Furqan" },
//         { region: "العامرية", translation: "Al-Amariyah" },
//         { region: "الإنشاءات", translation: "Al-Insha'at" },
//         { region: "جبل بدرو", translation: "Jabal Badro" },
//         { region: "الجميلية", translation: "Al-Jamiliyah" },
//         { region: "بني زيد", translation: "Bani Zaid" },
//         { region: "كرم الطراب", translation: "Karm al-Tarrab" }
//     ],

//     homs: [
//         { region: "البياضا", translation: "Al-Bayada" },
//         { region: "الخالدية", translation: "Al-Khalidiyah" },
//         { region: "جورة الشياح", translation: "Joura al-Shiyah" },
//         { region: "بابا عمرو", translation: "Baba Amro" },
//         { region: "غوطة", translation: "Ghota" },
//         { region: "انشاءات", translation: "Insha'at" },
//         { region: "وادي الذهب", translation: "Wadi al-Dahab" },
//         { region: "كرم الشامي", translation: "Karm al-Shami" },
//         { region: "الوعر", translation: "Al-Wa'er" },
//         { region: "القصور", translation: "Al-Qusour" },
//         { region: "المحطة", translation: "Al-Mahatta" },
//         { region: "عكرمة الجديدة", translation: "Akrama al-Jadidah" },
//         { region: "عكرمة القديمة", translation: "Akrama al-Qadeemah" },
//         { region: "ضاحية الوليد", translation: "Dahiat al-Walid" },
//         { region: "المخيم", translation: "Al-Mukhayyam" },
//         { region: "الشماس", translation: "Al-Shamas" },
//         { region: "الإدخار", translation: "Al-Idkhar" },
//         { region: "النزهة", translation: "Al-Nuzha" },
//         { region: "الحميدية", translation: "Al-Hamidiyah" },
//         { region: "كرم الزيتون", translation: "Karm al-Zaytoun" }
//     ],

//     hama: [
//         { region: "الحاضر", translation: "Al-Hadir" },
//         { region: "الصابونية", translation: "Al-Sabouniyah" },
//         { region: "الأربعين", translation: "Al-Arba'in" },
//         { region: "الشريعة", translation: "Al-Shari'ah" },
//         { region: "الحميدية", translation: "Al-Hamidiyah" },
//         { region: "كازو", translation: "Kazo" },
//         { region: "طيبة الإمام", translation: "Taybat al-Imam" },
//         { region: "محردة", translation: "Mahardah" },
//         { region: "صوران", translation: "Souran" },
//         { region: "كفر زيتا", translation: "Kafr Zita" },
//         { region: "مصياف", translation: "Masyaf" },
//         { region: "السقيلبية", translation: "Al-Suqaylabiyah" },
//         { region: "سلمية", translation: "Salamiyah" },
//         { region: "الغاب", translation: "Al-Ghab" }
//     ],

//     lattakia: [
//         { region: "الصليبة", translation: "Al-Salibah" },
//         { region: "الأزهرية", translation: "Al-Azhariyah" },
//         { region: "زراعة", translation: "Zira'ah" },
//         { region: "الرمل الجنوبي", translation: "Al-Raml al-Janubi" },
//         { region: "الرمل الشمالي", translation: "Al-Raml al-Shamali" },
//         { region: "الشاطئ الأزرق", translation: "Al-Shati al-Azraq" },
//         { region: "الشيراتون", translation: "Al-Sheraton" },
//         { region: "المشروع", translation: "Al-Mashrou" },
//         { region: "الطابيات", translation: "Al-Tabiyat" },
//         { region: "بسنادا", translation: "Basnadah" },
//         { region: "قرداحة", translation: "Qardaha" },
//         { region: "جبلة", translation: "Jableh" },
//         { region: "بانياس", translation: "Banyas" },
//         { region: "الحفة", translation: "Al-Haffeh" }
//     ],

//     tartus: [
//         { region: "المدينة القديمة", translation: "Al-Madinah al-Qadeemah" },
//         { region: "الثورة", translation: "Al-Thawrah" },
//         { region: "المشتل", translation: "Al-Mashtal" },
//         { region: "وادي العيون", translation: "Wadi al-Oyoun" },
//         { region: "صافيتا", translation: "Safita" },
//         { region: "الشيخ بدر", translation: "Al-Sheikh Badr" },
//         { region: "القدموس", translation: "Al-Qadmous" },
//         { region: "الدريكيش", translation: "Al-Dreikish" },
//         { region: "مصياف", translation: "Masyaf" },
//         { region: "بانياس", translation: "Banyas" }
//     ],

//     idlib: [
//         { region: "حي المطار", translation: "Hayy al-Matar" },
//         { region: "الأوقاف", translation: "Al-Awqaf" },
//         { region: "الكورنيش", translation: "Al-Kornish" },
//         { region: "جسر الشغور", translation: "Jisr al-Shughour" },
//         { region: "أريحا", translation: "Ariha" },
//         { region: "معرة النعمان", translation: "Maarat al-Nu'man" },
//         { region: "سراقب", translation: "Saraqib" },
//         { region: "خان شيخون", translation: "Khan Shaykhun" },
//         { region: "حارم", translation: "Harim" },
//         { region: "سلقين", translation: "Salqin" },
//         { region: "الدانا", translation: "Al-Dana" }
//     ],

//     daraa: [
//         { region: "المحطة", translation: "Al-Mahatta" },
//         { region: "الصنمين", translation: "Al-Sanamin" },
//         { region: "طفس", translation: "Tafas" },
//         { region: "إنخل", translation: "Inkhil" },
//         { region: "الشيخ مسكين", translation: "Al-Sheikh Miskin" },
//         { region: "نوى", translation: "Nawa" },
//         { region: "بصرى الشام", translation: "Busra al-Sham" },
//         { region: "الحراك", translation: "Al-Hirak" },
//         { region: "جاسم", translation: "Jasim" },
//         { region: "المزيريب", translation: "Al-Muzayrib" },
//         { region: "الطيبة", translation: "Al-Taybah" }
//     ],

//     suweida: [
//         { region: "المدينة", translation: "Al-Madinah" },
//         { region: "صلخد", translation: "Salkhad" },
//         { region: "شهبا", translation: "Shahba" },
//         { region: "القريا", translation: "Al-Quraya" },
//         { region: "عرمان", translation: "Arman" },
//         { region: "ظهر الجبل", translation: "Dahr al-Jabal" },
//         { region: "عتيل", translation: "Atil" },
//         { region: "المجدل", translation: "Al-Majdal" },
//         { region: "رساس", translation: "Rasas" }
//     ],

//     quneitra: [
//         { region: "القنيطرة", translation: "Quneitra" },
//         { region: "فيق", translation: "Fiq" },
//         { region: "خان أرنبة", translation: "Khan Arnabah" },
//         { region: "مسعدة", translation: "Mas'adah" },
//         { region: "بيت جن", translation: "Beit Jan" },
//         { region: "عين قنية", translation: "Ain Qinyah" }
//     ],

//     deir_ez_zor: [
//         { region: "الحوائج", translation: "Al-Hawayij" },
//         { region: "الجورة", translation: "Al-Joura" },
//         { region: "المطار الشرقي", translation: "Al-Matar al-Sharqi" },
//         { region: "العمال", translation: "Al-Ummal" },
//         { region: "الحميدية", translation: "Al-Hamidiyah" },
//         { region: "القصور", translation: "Al-Qusour" },
//         { region: "الميادين", translation: "Al-Mayadin" },
//         { region: "البوكمال", translation: "Al-Bukamal" },
//         { region: "التبني", translation: "Al-Tibni" }
//     ],

//     raqqa: [
//         { region: "المدينة", translation: "Al-Madinah" },
//         { region: "الثقافة", translation: "Al-Thaqafah" },
//         { region: "الصناعة", translation: "Al-Sina'ah" },
//         { region: "المعلمين", translation: "Al-Mu'allimin" },
//         { region: "الرمضانية", translation: "Al-Ramadaniyah" },
//         { region: "تل أبيض", translation: "Tal Abyad" },
//         { region: "الطبقة", translation: "Al-Tabqah" },
//         { region: "الثورة", translation: "Al-Thawrah" }
//     ],

//     hasakah: [
//         { region: "المدينة", translation: "Al-Madinah" },
//         { region: "العزيزية", translation: "Al-Aziziyah" },
//         { region: "الناصرة", translation: "Al-Nasirah" },
//         { region: "غويران", translation: "Ghweiran" },
//         { region: "القامشلي", translation: "Qamishli" },
//         { region: "المالكية", translation: "Al-Malikiyah" },
//         { region: "رأس العين", translation: "Ra's al-Ayn" },
//         { region: "الدرباسية", translation: "Al-Darbasiyah" },
//         { region: "المعبدة", translation: "Al-Ma'badah" },
//         { region: "الشدادي", translation: "Al-Shaddadi" }
//     ]
// };

// // دالة للحصول على المناطق حسب المحافظة المختارة
// export const getRegionsByGovernorate = (governorateKey) => {
//     return regions[governorateKey] || [];
// };

// // تحديث الدالة homes لتكون أكثر مرونة
// export const homes = regions.homs; // الافتراضي حمص

// // دالة لتحديث المناطق حسب المحافظة المختارة
// export const updateRegionsForGovernorate = (governorateKey) => {
//     return getRegionsByGovernorate(governorateKey);
// };






// export const subjects = [
// { key: "internal", name: "الباطنية", icon: Stethoscope },
// { key: "cardiology", name: "أمراض القلب", icon: HeartPulse },
// { key: "dermatology", name: "الأمراض الجلدية", icon: Microscope },
// { key: "ophthalmology", name: "طب العيون", icon: Eye },
// { key: "orthopedics", name: "العظام", icon: Bone },
// { key: "vaccines", name: "اللقاحات", icon: Syringe },
// { key: "pediatrics", name: "طب الأطفال", icon: Baby },
// { key: "gynecology", name: "النساء والولادة", icon: Venus },
// { key: "surgery", name: "الجراحة العامة", icon: Scissors },
// { key: "fitness", name: "الصحة العامة", icon: Dumbbell },
// { key: "neurology", name: "طب الأعصاب", icon: Brain },
// { key: "ent", name: "أنف أذن حنجرة", icon: Ear },
// { key: "oncology", name: "الأورام", icon: Shield },
// // psychiatry: replaced Smile -> UserCheck (more appropriate and exists in lucide)
// { key: "psychiatry", name: "الطب النفسي", icon: UserCheck },
// { key: "infectious", name: "الأمراض المعدية", icon: Thermometer },
// { key: "lab", name: "المختبرات", icon: TestTube },
// // radiology: XRay is not exported by lucide-react. use Scan instead.
// { key: "radiology", name: "الأشعة", icon: Scan },
// { key: "emergency", name: "الطوارئ", icon: Ambulance },
// { key: "family", name: "طب الأسرة", icon: Users },
// { key: "nutrition", name: "التغذية", icon: Apple },
// // dentistry: Tooth not in lucide main set. use Smile as a friendly substitute.
// { key: "dentistry", name: "طب الأسنان", icon: Smile },
// // urology: Kidney icon not available. use Droplet as a representative substitute.
// { key: "urology", name: "طب المسالك البولية", icon: Droplet },
// { key: "pulmonology", name: "طب الجهاز التنفسي", icon: Wind },
// // nurse: Nurse not available in main set. use User.
// { key: "nurse", name: "ممرض", icon: User },
// { key: "pharmacy", name: "صيدلية", icon: Pill },
// ];






// // export const subjects = [
// //   { key: 'internal', name: 'الباطنية', icon: 'https://img.icons8.com/color/96/000000/stethoscope.png' },
// //   { key: 'cardiology', name: 'أمراض القلب', icon: 'https://img.icons8.com/color/96/000000/heart-with-pulse.png' },
// //   { key: 'dermatology', name: 'الأمراض الجلدية', icon: 'https://img.icons8.com/color/96/000000/microscope.png' },
// //   { key: 'ophthalmology', name: 'طب العيون', icon: 'https://img.icons8.com/color/96/000000/eye.png' },
// //   { key: 'orthopedics', name: 'العظام', icon: 'https://img.icons8.com/color/96/000000/bone.png' },
// //   { key: 'vaccines', name: 'اللقاحات', icon: 'https://img.icons8.com/color/96/000000/syringe.png' },
// //   { key: 'pediatrics', name: 'طب الأطفال', icon: 'https://img.icons8.com/color/96/000000/baby.png' },
// //   { key: 'gynecology', name: 'النساء والولادة', icon: 'https://img.icons8.com/color/96/000000/venus.png' },
// //   { key: 'surgery', name: 'الجراحة العامة', icon: 'https://img.icons8.com/color/96/000000/scissors.png' },
// //   { key: 'fitness', name: 'الصحة العامة', icon: 'https://img.icons8.com/color/96/000000/fitness.png' },
// //   { key: 'neurology', name: 'طب الأعصاب', icon: 'https://img.icons8.com/color/96/000000/brain.png' },
// //   { key: 'ent', name: 'أنف أذن حنجرة', icon: 'https://img.icons8.com/color/96/000000/ear.png' },
// //   { key: 'oncology', name: 'الأورام', icon: 'https://img.icons8.com/color/96/000000/shield.png' },
// //   { key: 'psychiatry', name: 'الطب النفسي', icon: 'https://img.icons8.com/color/96/000000/smile.png' },
// //   { key: 'infectious', name: 'الأمراض المعدية', icon: 'https://img.icons8.com/color/96/000000/thermometer.png' },
// //   { key: 'lab', name: 'المختبرات', icon: 'https://img.icons8.com/color/96/000000/test-tube.png' },
// //   { key: 'radiology', name: 'الأشعة', icon: 'https://img.icons8.com/color/96/000000/x-ray.png' },
// //   { key: 'emergency', name: 'الطوارئ', icon: 'https://img.icons8.com/color/96/000000/ambulance.png' },
// //   { key: 'family', name: 'طب الأسرة', icon: 'https://img.icons8.com/color/96/000000/user.png' },
// //   { key: 'nutrition', name: 'التغذية', icon: 'https://img.icons8.com/color/96/000000/apple.png' },
// //   { key: 'dentistry', name: 'طب الأسنان', icon: 'https://img.icons8.com/color/96/000000/tooth.png' },
// //   { key: 'urology', name: 'طب المسالك البولية', icon: 'https://img.icons8.com/color/96/000000/kidney.png' },
// //   { key: 'pulmonology', name: 'طب الجهاز التنفسي', icon: 'https://img.icons8.com/color/96/000000/lungs.png' },

// //   // العناصر المضافة
// //   { key: 'nurse', name: 'ممرض', icon: 'https://img.icons8.com/color/96/000000/nurse-female.png' },
// //   { key: 'pharmacy', name: 'صيدلية', icon: 'https://img.icons8.com/color/96/000000/pill.png' },
// // ];




// export const assets = {
//     header_image_1,
//     header_image_2,
//     header_image_3,
//     about_image,
//     middle_image
// }

// export const city = [
//     { key: 'homes', name: "حمص" },
//     { key: 'any', name: "اليوم حمص وغذاً العالماً، قريباً باقي المحافظات" },
// ];


// export const grades = [
//   { value: 'private_clinic', name: 'عيادة طبية خاصة' },
//   { value: 'dental_clinic', name: 'عيادة أسنان' },
//   { value: 'pharmacy', name: 'صيدلية' },
//   { value: 'private_hospital', name: 'مشفى خاص' },
//   { value: 'public_hospital', name: 'مشفى عام' },
//   { value: 'first_aid', name: 'اسعافات أولية' },
//   { value: 'face_to_face', name: 'زيارة طبيب وجه لوجه' },
//   { value: 'home_emergency', name: 'اسعافات منزلية' },
//   { value: 'iv_cannulation', name: 'فتح وريد' },
//   { value: 'injection', name: 'اعطاء إبرة' },
//   { value: 'cupping', name: 'حجامة' },
//   { value: 'physiotherapy', name: 'معالجة فيزيائية' },
//   { value: 'consultation', name: 'استشارة طبية' }
// ];


// // export const grades = [
// //     { value: 'all', name: 'جميع الحالات المرضية' },
// //     { value: '1', name: 'مرض في أسنان ' },
// //     { value: '2', name: ' مرض أنف أذن حنجرة' },
// //     { value: '3', name: ' حالة نسائية' },
// //     { value: '4', name: ' حالة داخلية' },
// //     { value: '5', name: ' مرض عظمية' },
// //     { value: '6', name: ' مرض عملية جراحية' },
// //     { value: '7', name: 'مرض في العيون ' },
// //     { value: '8', name: ' مرض في الجهاز البولي' },
// //     { value: '9', name: 'أمراض أطفال ' }
// // ];


// export const generateTimeSlots = (start = "00:00", end = "23:59", interval = 15) => {
//   const slots = [];
//   let [hour, minute] = start.split(":").map(Number);
//   const [endHour, endMinute] = end.split(":").map(Number);

//   while (hour < endHour || (hour === endHour && minute <= endMinute)) {
//     const value = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;

//     // تحويل لصيغة عربية (ص/م)
//     let suffix = hour < 12 ? "ص" : "م";
//     let displayHour = hour % 12 === 0 ? 12 : hour % 12;
//     const label = `${displayHour}:${String(minute).padStart(2, "0")} ${suffix}`;

//     slots.push({
//       value,
//       label,
//       id: slots.length,
//     });

//     // زيادة بالفاصل (interval)
//     minute += interval;
//     if (minute >= 60) {
//       hour++;
//       minute = 0;
//     }
//   }

//   return slots;
// };

// // ⬅️ استدعاء لجميع ساعات اليوم بفاصل 15 دقيقة
// export const timeSlots = generateTimeSlots("00:00", "23:59", 15);

// // export const generateTimeSlots = (start = "05:00", end = "22:00", interval = 15) => {
// //   const slots = [];
// //   let [hour, minute] = start.split(":").map(Number);
// //   const [endHour, endMinute] = end.split(":").map(Number);

// //   while (hour < endHour || (hour === endHour && minute <= endMinute)) {
// //     const value = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;

// //     // تحويل لصيغة عربية (ص/م)
// //     let suffix = hour < 12 ? "ص" : "م";
// //     let displayHour = hour % 12 === 0 ? 12 : hour % 12;
// //     const label = `${displayHour}:${String(minute).padStart(2, "0")} ${suffix}`;

// //     slots.push({
// //       value,
// //       label,
// //       id: slots.length,
// //     });

// //     // زيادة بالفاصل (interval)
// //     minute += interval;
// //     if (minute >= 60) {
// //       hour++;
// //       minute = 0;
// //     }
// //   }

// //   return slots;
// // };

// // // استدعاء مباشر لتوليد جميع الأوقات
// // export const timeSlots = generateTimeSlots("05:00", "22:00", 15);

// // export const timeSlots = [
// //     { value: '07:00', label: '7:00 ص', id: 0 },
// //     { value: '08:00', label: '8:00 ص', id: 1 },
// //     { value: '09:00', label: '9:00 ص', id: 2 },
// //     { value: '10:00', label: '10:00 ص', id: 3 },
// //     { value: '11:00', label: '11:00 ص', id: 4 },
// //     { value: '12:00', label: '12:00 م', id: 5 },
// //     { value: '13:00', label: '1:00 م', id: 6 },
// //     { value: '14:00', label: '2:00 م', id: 7 },
// //     { value: '15:00', label: '3:00 م', id: 8 },
// //     { value: '16:00', label: '4:00 م', id: 9 },
// //     { value: '17:00', label: '5:00 م', id: 10 },
// //     { value: '18:00', label: '6:00 م', id: 11 },
// //     { value: '19:00', label: '7:00 م', id: 12 },
// //     { value: '20:00', label: '8:00 م', id: 13 },
// //     { value: '21:00', label: '9:00 م', id: 14 },
// //     { value: '22:00', label: '10:00 م', id: 15 }
// // ];


// export const daysInArabic = [
//     { key: 'sunday', day: 'الاحد', num: 0 },
//     { key: 'monday', day: 'الاثنين', num: 1 },
//     { key: 'tuesday', day: 'الثلاثاء', num: 2 },
//     { key: 'wednesday', day: 'الاربعاء', num: 3 },
//     { key: 'thursday', day: 'الخميس', num: 4 },
//     { key: 'friday', day: 'الجمعة', num: 5 },
//     { key: 'saturday', day: 'السبت', num: 6 }
// ];

// export const homes = [
//     { region: "البياضا", translation: "Al-Bayada" },
//     { region: "الخالدية", translation: "Al-Khalidiyah" },
//     { region: "جورة الشياح", translation: "Joura al-Shiyah" },
//     { region: "بابا عمرو", translation: "Baba Amro" },
//     { region: "غوطة", translation: "Ghota" },
//     { region: "انشاءات", translation: "Insha'at" },
//     { region: "وادي الذهب", translation: "Wadi al-Dahab" },
//     { region: "كرم الشامي", translation: "Karm al-Shami" },
//     { region: "الوعر", translation: "Al-Wa'er" },
//     { region: "القصور", translation: "Al-Qusour" },
//     { region: "المحطة", translation: "Al-Mahatta" },
//     { region: "عكرمة الجديدة", translation: "Akrama al-Jadidah" },
//     { region: "عكرمة القديمة", translation: "Akrama al-Qadeemah" },
//     { region: "ضاحية الوليد", translation: "Dahiat al-Walid" },
//     { region: "المخيم", translation: "Al-Mukhayyam" },
//     { region: "الشماس", translation: "Al-Shamas" },
//     { region: "الإدخار", translation: "Al-Idkhar" },
//     { region: "النزهة", translation: "Al-Nuzha" }
// ];

// export const translateDayToArabic = (day) => {
//     return daysInArabic.filter(enDay => enDay.key === day)[0].day;
// }

// export const getTime = (time) => {
//     return timeSlots.filter(t => t.value === time)[0].label;
// }

// export const getDayKeyByNumber = (dayNum) => {
//     if (dayNum > 6 && dayNum < 0) {
//         throw new Error("invalid day number");
//     }
//     return daysInArabic.filter(day => day.num === dayNum)[0].key;
// }

// export function getNextDayDate(dayName, tar) {
//     const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
//     const today = new Date();
//     const todayIndex = today.getDay(); // 0 (Sunday) to 6 (Saturday)
//     const targetIndex = daysOfWeek.findIndex(day => day.toLowerCase() === dayName.toLowerCase());

//     if (targetIndex === -1) {
//         return;
//     }

//     let daysUntilNext; // Always go forward, even if same day

//     if (targetIndex < new Date().getDay()) {
//         daysUntilNext = (targetIndex - todayIndex + 7) % 7 || 7;
//     } else {
//         daysUntilNext = targetIndex - todayIndex
//     }

//     const nextDate = new Date(today);
//     nextDate.setDate(today.getDate() + daysUntilNext);
//     return nextDate.toLocaleDateString("en-US");
// }

// export const getRegionKeyByRegionName = (regionName) => {
//     const regionKey = homes.filter(region => region.translation === regionName)[0];

//     if (regionKey) {
//         return regionKey.region;
//     } else {
//         return "Not Found";
//     }
// }

// export const getSubjectNameByKey = (key) => {
//     if (key) {
//         return subjects.filter(s => s.key === key)[0].name;
//     } else {
//         return key;
//     }
// }

// export const getStatusBadge = (status) => {
//     const badges = {
//         upcoming: { color: 'bg-blue-100 text-blue-800', text: 'قادم' },
//         completed: { color: 'bg-green-100 text-green-800', text: 'مكتمل' },
//         cancelled: { color: 'bg-red-100 text-red-800', text: 'ملغي' }
//     };
//     return badges[status] || badges.upcoming;
// };

// export const formatDate = (dateString) => {
//     const date = new Date(dateString).toLocaleDateString("en-US").split("/").reverse();
//     date[2] = date[2].length === 1 ? "0" + date[2] : date[2];
//     date[1] = date[1].length === 1 ? "0" + date[1] : date[1];
//     [date[2], date[1]] = [date[1], date[2]];
//     return date.join("-");
// }

// export const formatTime = (timeString) => {
//     const slot = timeSlots.filter(slot => slot.value === timeString)[0];
//     return slot ? slot?.label : timeString;
// };

// export const getDayInArabic = (dayNameInEnglish) => {
//     if (dayNameInEnglish) {
//         return daysInArabic.filter(dayInfo => dayInfo.key === dayNameInEnglish)[0].day;
//     }
// }

// export const getTimeSlotId = (slot) => {
//     const s = timeSlots.filter(s => s.value === slot)[0];
//     return s ? s.id:0 ;
// }

// export const getGradeNameByNumber = (gradeNum) => {
//     if (gradeNum && gradeNum < 10) {
//         return grades.filter(grade => parseInt(grade.value) === gradeNum)[0].name;
//     }
// }

// export const getGeoLocation = async () => {
//     try {
//         let x = setInterval(
//             ()=>{
//                 if (navigator.geolocation) {
//                 let lat, lng;

//                 navigator.geolocation.getCurrentPosition(
//                     ({ coords: { latitude, longitude } }) => {
//                         lat = latitude;

//                         lng = longitude;
//                     }, 
//                     (error) => {
//                         console.log(error);
//                     },
//                     {
//                         enableHighAccuracy: true,
//                         timeout: 1000000
//                     }
//                 );

//                 clearInterval(x);

//                 return [lng, lat];
//               }
//             }
//        ,500 )
//     } catch (e) {
//         return [];
//     }
// }













import physics from './images/physics.png'
import science from './images/science.png'
import maths from './images/maths.png'
import chm from './images/chemistry.png'
import geo from './images/geography.png'
import hist from './images/history.png'
import ar from './images/books.png'
import en from './images/engllish.png'
import about_image from './images/about_image.jpg'
import header_image_1 from './images/header_image_1.jpg'
import header_image_2 from './images/header_image_2.jpg'
import header_image_3 from './images/header_image_3.png'
import middle_image from './images/middle_image.jpg'

import {
Stethoscope,
HeartPulse,
Microscope,
Eye,
Bone,
Syringe,
Baby,
Venus,
Scissors,
Dumbbell,
Brain,
Ear,
Shield,
UserCheck,
Thermometer,
TestTube,
Scan,
Ambulance,
Users,
Apple,
Smile,
Droplet,
Wind,
User,
Pill,
} from "lucide-react";

// تصدير الصور
export const assets = {
    header_image_1,
    header_image_2,
    header_image_3,
    about_image,
    middle_image
}

// المحافظات السورية
export const city = [
    { key: 'damascus', name: "دمشق" },
    { key: 'damascus_countryside', name: "ريف دمشق" },
    { key: 'aleppo', name: "حلب" },
    { key: 'homs', name: "حمص" },
    { key: 'hama', name: "حماة" },
    { key: 'lattakia', name: "اللاذقية" },
    { key: 'tartus', name: "طرطوس" },
    { key: 'idlib', name: "إدلب" },
    { key: 'daraa', name: "درعا" },
    { key: 'suweida', name: "السويداء" },
    { key: 'quneitra', name: "القنيطرة" },
    { key: 'deir_ez_zor', name: "دير الزور" },
    { key: 'raqqa', name: "الرقة" },
    { key: 'hasakah', name: "الحسكة" }
];

// المناطق حسب كل محافظة
export const regions = {
    damascus: [
        { region: "الشاغور", translation: "Al-Shaghour" },
        { region: "باب توما", translation: "Bab Touma" },
        { region: "القصاع", translation: "Al-Qassa" },
        { region: "الصالحية", translation: "Al-Salihiyah" },
        { region: "المهاجرين", translation: "Al-Muhajirin" },
        { region: "أبو رمانة", translation: "Abu Rummanah" },
        { region: "المالكي", translation: "Al-Malki" },
        { region: "الروضة", translation: "Al-Rawdah" },
        { region: "كفرسوسة", translation: "Kafr Souseh" },
        { region: "المزة", translation: "Al-Mazza" },
        { region: "دمر", translation: "Dummar" },
        { region: "المزرعة", translation: "Al-Mazra'a" },
        { region: "برزة", translation: "Barzah" },
        { region: "التجارة", translation: "Al-Tijara" },
        { region: "جوبر", translation: "Jobar" },
        { region: "زملكا", translation: "Zamalka" },
        { region: "عين ترما", translation: "Ain Terma" }
    ],

    damascus_countryside: [
        { region: "دوما", translation: "Douma" },
        { region: "الزبداني", translation: "Al-Zabadani" },
        { region: "بلودان", translation: "Bloudan" },
        { region: "مضايا", translation: "Madaya" },
        { region: "عرسال", translation: "Arsal" },
        { region: "النبك", translation: "Al-Nabk" },
        { region: "يبرود", translation: "Yabroud" },
        { region: "معلولا", translation: "Maaloula" },
        { region: "صيدنايا", translation: "Saidnaya" },
        { region: "قطنا", translation: "Qatana" },
        { region: "الكسوة", translation: "Al-Kiswah" },
        { region: "داريا", translation: "Daraya" },
        { region: "المعضمية", translation: "Al-Mu'addamiyah" },
        { region: "قدسيا", translation: "Qudsaya" },
        { region: "حرستا", translation: "Harasta" },
        { region: "عربين", translation: "Arbin" },
        { region: "سقبا", translation: "Saqba" },
        { region: "مليحة", translation: "Maliha" }
    ],

    aleppo: [
        { region: "العزيزية", translation: "Al-Aziziyah" },
        { region: "الشعار", translation: "Al-Sha'ar" },
        { region: "بستان الباشا", translation: "Bustan al-Basha" },
        { region: "الصاخور", translation: "Al-Sakhour" },
        { region: "الحيدرية", translation: "Al-Haidariyah" },
        { region: "الميدان", translation: "Al-Maydan" },
        { region: "العقبة", translation: "Al-Aqabah" },
        { region: "الفردوس", translation: "Al-Firdous" },
        { region: "الأشرفية", translation: "Al-Ashrafiyah" },
        { region: "الموكامبو", translation: "Al-Mogambo" },
        { region: "الحمدانية", translation: "Al-Hamdaniyah" },
        { region: "الفرقان", translation: "Al-Furqan" },
        { region: "العامرية", translation: "Al-Amariyah" },
        { region: "الإنشاءات", translation: "Al-Insha'at" },
        { region: "جبل بدرو", translation: "Jabal Badro" },
        { region: "الجميلية", translation: "Al-Jamiliyah" },
        { region: "بني زيد", translation: "Bani Zaid" },
        { region: "كرم الطراب", translation: "Karm al-Tarrab" }
    ],

    homs: [
        { region: "البياضا", translation: "Al-Bayada" },
        { region: "الخالدية", translation: "Al-Khalidiyah" },
        { region: "جورة الشياح", translation: "Joura al-Shiyah" },
        { region: "بابا عمرو", translation: "Baba Amro" },
        { region: "غوطة", translation: "Ghota" },
        { region: "انشاءات", translation: "Insha'at" },
        { region: "وادي الذهب", translation: "Wadi al-Dahab" },
        { region: "كرم الشامي", translation: "Karm al-Shami" },
        { region: "الوعر", translation: "Al-Wa'er" },
        { region: "القصور", translation: "Al-Qusour" },
        { region: "المحطة", translation: "Al-Mahatta" },
        { region: "عكرمة الجديدة", translation: "Akrama al-Jadidah" },
        { region: "عكرمة القديمة", translation: "Akrama al-Qadeemah" },
        { region: "ضاحية الوليد", translation: "Dahiat al-Walid" },
        { region: "المخيم", translation: "Al-Mukhayyam" },
        { region: "الشماس", translation: "Al-Shamas" },
        { region: "الإدخار", translation: "Al-Idkhar" },
        { region: "النزهة", translation: "Al-Nuzha" },
        { region: "الحميدية", translation: "Al-Hamidiyah" },
        { region: "كرم الزيتون", translation: "Karm al-Zaytoun" }
    ],

    hama: [
        { region: "الحاضر", translation: "Al-Hadir" },
        { region: "الصابونية", translation: "Al-Sabouniyah" },
        { region: "الأربعين", translation: "Al-Arba'in" },
        { region: "الشريعة", translation: "Al-Shari'ah" },
        { region: "الحميدية", translation: "Al-Hamidiyah" },
        { region: "كازو", translation: "Kazo" },
        { region: "طيبة الإمام", translation: "Taybat al-Imam" },
        { region: "محردة", translation: "Mahardah" },
        { region: "صوران", translation: "Souran" },
        { region: "كفر زيتا", translation: "Kafr Zita" },
        { region: "مصياف", translation: "Masyaf" },
        { region: "السقيلبية", translation: "Al-Suqaylabiyah" },
        { region: "سلمية", translation: "Salamiyah" },
        { region: "الغاب", translation: "Al-Ghab" }
    ],

    lattakia: [
        { region: "الصليبة", translation: "Al-Salibah" },
        { region: "الأزهرية", translation: "Al-Azhariyah" },
        { region: "زراعة", translation: "Zira'ah" },
        { region: "الرمل الجنوبي", translation: "Al-Raml al-Janubi" },
        { region: "الرمل الشمالي", translation: "Al-Raml al-Shamali" },
        { region: "الشاطئ الأزرق", translation: "Al-Shati al-Azraq" },
        { region: "الشيراتون", translation: "Al-Sheraton" },
        { region: "المشروع", translation: "Al-Mashrou" },
        { region: "الطابيات", translation: "Al-Tabiyat" },
        { region: "بسنادا", translation: "Basnadah" },
        { region: "قرداحة", translation: "Qardaha" },
        { region: "جبلة", translation: "Jableh" },
        { region: "بانياس", translation: "Banyas" },
        { region: "الحفة", translation: "Al-Haffeh" }
    ],

    tartus: [
        { region: "المدينة القديمة", translation: "Al-Madinah al-Qadeemah" },
        { region: "الثورة", translation: "Al-Thawrah" },
        { region: "المشتل", translation: "Al-Mashtal" },
        { region: "وادي العيون", translation: "Wadi al-Oyoun" },
        { region: "صافيتا", translation: "Safita" },
        { region: "الشيخ بدر", translation: "Al-Sheikh Badr" },
        { region: "القدموس", translation: "Al-Qadmous" },
        { region: "الدريكيش", translation: "Al-Dreikish" },
        { region: "مصياف", translation: "Masyaf" },
        { region: "بانياس", translation: "Banyas" }
    ],

    idlib: [
        { region: "حي المطار", translation: "Hayy al-Matar" },
        { region: "الأوقاف", translation: "Al-Awqaf" },
        { region: "الكورنيش", translation: "Al-Kornish" },
        { region: "جسر الشغور", translation: "Jisr al-Shughour" },
        { region: "أريحا", translation: "Ariha" },
        { region: "معرة النعمان", translation: "Maarat al-Nu'man" },
        { region: "سراقب", translation: "Saraqib" },
        { region: "خان شيخون", translation: "Khan Shaykhun" },
        { region: "حارم", translation: "Harim" },
        { region: "سلقين", translation: "Salqin" },
        { region: "الدانا", translation: "Al-Dana" }
    ],

    daraa: [
        { region: "المحطة", translation: "Al-Mahatta" },
        { region: "الصنمين", translation: "Al-Sanamin" },
        { region: "طفس", translation: "Tafas" },
        { region: "إنخل", translation: "Inkhil" },
        { region: "الشيخ مسكين", translation: "Al-Sheikh Miskin" },
        { region: "نوى", translation: "Nawa" },
        { region: "بصرى الشام", translation: "Busra al-Sham" },
        { region: "الحراك", translation: "Al-Hirak" },
        { region: "جاسم", translation: "Jasim" },
        { region: "المزيريب", translation: "Al-Muzayrib" },
        { region: "الطيبة", translation: "Al-Taybah" }
    ],

    suweida: [
        { region: "المدينة", translation: "Al-Madinah" },
        { region: "صلخد", translation: "Salkhad" },
        { region: "شهبا", translation: "Shahba" },
        { region: "القريا", translation: "Al-Quraya" },
        { region: "عرمان", translation: "Arman" },
        { region: "ظهر الجبل", translation: "Dahr al-Jabal" },
        { region: "عتيل", translation: "Atil" },
        { region: "المجدل", translation: "Al-Majdal" },
        { region: "رساس", translation: "Rasas" }
    ],

    quneitra: [
        { region: "القنيطرة", translation: "Quneitra" },
        { region: "فيق", translation: "Fiq" },
        { region: "خان أرنبة", translation: "Khan Arnabah" },
        { region: "مسعدة", translation: "Mas'adah" },
        { region: "بيت جن", translation: "Beit Jan" },
        { region: "عين قنية", translation: "Ain Qinyah" }
    ],

    deir_ez_zor: [
        { region: "الحوائج", translation: "Al-Hawayij" },
        { region: "الجورة", translation: "Al-Joura" },
        { region: "المطار الشرقي", translation: "Al-Matar al-Sharqi" },
        { region: "العمال", translation: "Al-Ummal" },
        { region: "الحميدية", translation: "Al-Hamidiyah" },
        { region: "القصور", translation: "Al-Qusour" },
        { region: "الميادين", translation: "Al-Mayadin" },
        { region: "البوكمال", translation: "Al-Bukamal" },
        { region: "التبني", translation: "Al-Tibni" }
    ],

    raqqa: [
        { region: "المدينة", translation: "Al-Madinah" },
        { region: "الثقافة", translation: "Al-Thaqafah" },
        { region: "الصناعة", translation: "Al-Sina'ah" },
        { region: "المعلمين", translation: "Al-Mu'allimin" },
        { region: "الرمضانية", translation: "Al-Ramadaniyah" },
        { region: "تل أبيض", translation: "Tal Abyad" },
        { region: "الطبقة", translation: "Al-Tabqah" },
        { region: "الثورة", translation: "Al-Thawrah" }
    ],

    hasakah: [
        { region: "المدينة", translation: "Al-Madinah" },
        { region: "العزيزية", translation: "Al-Aziziyah" },
        { region: "الناصرة", translation: "Al-Nasirah" },
        { region: "غويران", translation: "Ghweiran" },
        { region: "القامشلي", translation: "Qamishli" },
        { region: "المالكية", translation: "Al-Malikiyah" },
        { region: "رأس العين", translation: "Ra's al-Ayn" },
        { region: "الدرباسية", translation: "Al-Darbasiyah" },
        { region: "المعبدة", translation: "Al-Ma'badah" },
        { region: "الشدادي", translation: "Al-Shaddadi" }
    ]
};

// دالة للحصول على المناطق حسب المحافظة المختارة
export const getRegionsByGovernorate = (governorateKey) => {
    return regions[governorateKey] || [];
};

// للتوافق مع الكود القديم - مناطق حمص فقط
export const homes = regions.homs;

// التخصصات الطبية
export const subjects = [
    { key: "internal", name: "الباطنية", icon: Stethoscope },
    { key: "cardiology", name: "أمراض القلب", icon: HeartPulse },
    { key: "dermatology", name: "الأمراض الجلدية", icon: Microscope },
    { key: "ophthalmology", name: "طب العيون", icon: Eye },
    { key: "orthopedics", name: "العظام", icon: Bone },
    { key: "vaccines", name: "اللقاحات", icon: Syringe },
    { key: "pediatrics", name: "طب الأطفال", icon: Baby },
    { key: "gynecology", name: "النساء والولادة", icon: Venus },
    { key: "surgery", name: "الجراحة العامة", icon: Scissors },
    { key: "fitness", name: "الصحة العامة", icon: Dumbbell },
    { key: "neurology", name: "طب الأعصاب", icon: Brain },
    { key: "ent", name: "أنف أذن حنجرة", icon: Ear },
    { key: "oncology", name: "الأورام", icon: Shield },
    { key: "psychiatry", name: "الطب النفسي", icon: UserCheck },
    { key: "infectious", name: "الأمراض المعدية", icon: Thermometer },
    { key: "lab", name: "المختبرات", icon: TestTube },
    { key: "radiology", name: "الأشعة", icon: Scan },
    { key: "emergency", name: "الطوارئ", icon: Ambulance },
    { key: "family", name: "طب الأسرة", icon: Users },
    { key: "nutrition", name: "التغذية", icon: Apple },
    { key: "dentistry", name: "طب الأسنان", icon: Smile },
    { key: "urology", name: "طب المسالك البولية", icon: Droplet },
    { key: "pulmonology", name: "طب الجهاز التنفسي", icon: Wind },
    { key: "nurse", name: "ممرض", icon: User },
    { key: "pharmacy", name: "صيدلية", icon: Pill }
];

// أنواع الخدمات الطبية
export const grades = [
    { value: 'private_clinic', name: 'عيادة طبية خاصة' },
    { value: 'dental_clinic', name: 'عيادة أسنان' },
    { value: 'pharmacy', name: 'صيدلية' },
    { value: 'private_hospital', name: 'مشفى خاص' },
    { value: 'public_hospital', name: 'مشفى عام' },
    { value: 'first_aid', name: 'اسعافات أولية' },
    { value: 'face_to_face', name: 'زيارة طبيب وجه لوجه' },
    { value: 'home_emergency', name: 'اسعافات منزلية' },
    { value: 'iv_cannulation', name: 'فتح وريد' },
    { value: 'injection', name: 'اعطاء إبرة' },
    { value: 'cupping', name: 'حجامة' },
    { value: 'physiotherapy', name: 'معالجة فيزيائية' },
    { value: 'consultation', name: 'استشارة طبية' }
];

// توليد فترات زمنية
export const generateTimeSlots = (start = "00:00", end = "23:59", interval = 15) => {
    const slots = [];
    let [hour, minute] = start.split(":").map(Number);
    const [endHour, endMinute] = end.split(":").map(Number);

    while (hour < endHour || (hour === endHour && minute <= endMinute)) {
        const value = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
        
        let suffix = hour < 12 ? "ص" : "م";
        let displayHour = hour % 12 === 0 ? 12 : hour % 12;
        const label = `${displayHour}:${String(minute).padStart(2, "0")} ${suffix}`;

        slots.push({
            value,
            label,
            id: slots.length,
        });

        minute += interval;
        if (minute >= 60) {
            hour++;
            minute = 0;
        }
    }

    return slots;
};

export const timeSlots = generateTimeSlots("00:00", "23:59", 15);

// الأيام بالعربية
export const daysInArabic = [
    { key: 'sunday', day: 'الاحد', num: 0 },
    { key: 'monday', day: 'الاثنين', num: 1 },
    { key: 'tuesday', day: 'الثلاثاء', num: 2 },
    { key: 'wednesday', day: 'الاربعاء', num: 3 },
    { key: 'thursday', day: 'الخميس', num: 4 },
    { key: 'friday', day: 'الجمعة', num: 5 },
    { key: 'saturday', day: 'السبت', num: 6 }
];

// الدوال المساعدة
export const translateDayToArabic = (day) => {
    const found = daysInArabic.find(enDay => enDay.key === day);
    return found ? found.day : '';
}

export const getTime = (time) => {
    const found = timeSlots.find(t => t.value === time);
    return found ? found.label : '';
}

export const getDayKeyByNumber = (dayNum) => {
    if (dayNum > 6 || dayNum < 0) {
        throw new Error("invalid day number");
    }
    const found = daysInArabic.find(day => day.num === dayNum);
    return found ? found.key : '';
}

export function getNextDayDate(dayName) {
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const today = new Date();
    const todayIndex = today.getDay();
    const targetIndex = daysOfWeek.findIndex(day => day.toLowerCase() === dayName.toLowerCase());

    if (targetIndex === -1) {
        return null;
    }

    let daysUntilNext = targetIndex - todayIndex;
    if (daysUntilNext <= 0) {
        daysUntilNext += 7;
    }

    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() + daysUntilNext);
    return nextDate.toLocaleDateString("en-US");
}

export const getRegionKeyByRegionName = (regionName) => {
    const regionKey = homes.find(region => region.translation === regionName);
    return regionKey ? regionKey.region : "Not Found";
}

export const getSubjectNameByKey = (key) => {
    if (!key) return '';
    const found = subjects.find(s => s.key === key);
    return found ? found.name : key;
}

export const getStatusBadge = (status) => {
    const badges = {
        upcoming: { color: 'bg-blue-100 text-blue-800', text: 'قادم' },
        completed: { color: 'bg-green-100 text-green-800', text: 'مكتمل' },
        cancelled: { color: 'bg-red-100 text-red-800', text: 'ملغي' }
    };
    return badges[status] || badges.upcoming;
};

export const formatDate = (dateString) => {
    const date = new Date(dateString).toLocaleDateString("en-US").split("/").reverse();
    date[2] = date[2].length === 1 ? "0" + date[2] : date[2];
    date[1] = date[1].length === 1 ? "0" + date[1] : date[1];
    [date[2], date[1]] = [date[1], date[2]];
    return date.join("-");
}

export const formatTime = (timeString) => {
    const slot = timeSlots.find(slot => slot.value === timeString);
    return slot ? slot.label : timeString;
};

export const getDayInArabic = (dayNameInEnglish) => {
    if (!dayNameInEnglish) return '';
    const found = daysInArabic.find(dayInfo => dayInfo.key === dayNameInEnglish);
    return found ? found.day : '';
}

export const getTimeSlotId = (slot) => {
    const s = timeSlots.find(s => s.value === slot);
    return s ? s.id : 0;
}

export const getGradeNameByNumber = (gradeNum) => {
    if (!gradeNum || gradeNum >= 10) return '';
    const found = grades.find(grade => parseInt(grade.value) === gradeNum);
    return found ? found.name : '';
}

export const getGeoLocation = async () => {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error('Geolocation is not supported'));
            return;
        }

        navigator.geolocation.getCurrentPosition(
            ({ coords: { latitude, longitude } }) => {
                resolve([longitude, latitude]);
            },
            (error) => {
                console.error('Geolocation error:', error);
                reject(error);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 600000
            }
        );
    });
}